// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-layout p,.default-layout li{font-size:1.2rem;line-height:1.5}@media (max-width: 767.98px){.default-layout h2{font-size:1.75rem}.default-layout .btn:not(.notifications-toggle):not(.contact-us-small):not(.btn-auto-width){width:100%}.default-layout p,.default-layout li{font-size:1.1rem}.default-layout .invisible{display:none}}.default-layout .sticky-phone{bottom:1rem;right:2rem}\n", ""]);
// Exports
module.exports = exports;
